export default __webpack_public_path__ + "locales/az/Article.json?hash=a486c00dc0af286e3421a34937605ef4";